import Vue from 'vue'
import { isArray, isPlainObject } from 'lodash'

const ensurePath = (object, path) => {
    if (path.length) {
        const [currentChunkName, currentChunkType] = path.shift().split('/')
        if (currentChunkType === 'Array') {
            if (!isArray(object[currentChunkName])) {
                Vue.set(object, currentChunkName, [])
            }
        } else {
            if (!isPlainObject(object[currentChunkName])) {
                Vue.set(object, currentChunkName, {})
            }
        }
        ensurePath(object[currentChunkName], path)
    }
}

export default ensurePath
